// Phase 6 — filter row at the top of the Аналитика screen.
//
// A tectonic-model dropdown + the auto-discovering GNSS-config
// accordion (Phase 6.6 B, replacing the hardcoded five-pill row).
// Single source-of-truth lives in the screen's useState; this
// component is fully controlled. Changes are emitted as a full
// new ``AnalyticsFilters`` object so the screen can blanket-
// invalidate the React Query cache on every change.

import { useAvailableConfigs } from '../../hooks/useAvailableConfigs';
import type { AnalyticsFilters as Filters } from '../../api/types';
import { GnssConfigsFilter } from './GnssConfigsFilter';

const TECTONIC_MODELS = ['NNR_MORVEL56', 'NUVEL_1A', 'ITRF2014', 'GRSM_21'] as const;

const TECTONIC_LABELS: Record<string, string> = {
  NNR_MORVEL56: 'NNR-MORVEL56',
  NUVEL_1A: 'NUVEL-1A',
  ITRF2014: 'ITRF2014',
  GRSM_21: 'GRSM 2.1',
};

export function AnalyticsFilters({
  value,
  onChange,
}: {
  value: Filters;
  onChange: (next: Filters) => void;
}) {
  // Phase 6.6 B — fetch the auto-discovering config list once per
  // mount; cache for 60s in the React Query store. The accordion
  // gracefully degrades to a five-pill fallback while the list is
  // in-flight or on a backend error.
  const availableConfigs = useAvailableConfigs();

  return (
    <div className="analytics-filters" data-testid="analytics-filters">
      <div className="filter-group">
        <label className="filter-label" htmlFor="analytics-tectonic-model">
          модель тектоники
        </label>
        <select
          id="analytics-tectonic-model"
          /* Phase 6.7 B — compose the analytics-screen-specific
             `filter-select` (sets size + monospace) with the
             cross-screen `gnss-qa-select` (sets chevron SVG +
             :focus-visible ring). Both declare `appearance:none`
             with identical resolved values, so the cascade is
             non-conflicting. */
          className="filter-select gnss-qa-select"
          value={value.tectonic_model ?? ''}
          onChange={(e) =>
            onChange({
              ...value,
              tectonic_model: e.target.value || null,
            })
          }
        >
          <option value="">все</option>
          {TECTONIC_MODELS.map((m) => (
            <option key={m} value={m}>
              {TECTONIC_LABELS[m]}
            </option>
          ))}
        </select>
      </div>

      <GnssConfigsFilter
        value={value}
        onChange={onChange}
        available={availableConfigs.data?.configs}
      />
    </div>
  );
}
